import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'approval', ...(require('/data/src/models/approval.js').default) });
app.model({ namespace: 'approvalFlow', ...(require('/data/src/models/approvalFlow.js').default) });
app.model({ namespace: 'approvalSetting', ...(require('/data/src/models/approvalSetting.js').default) });
app.model({ namespace: 'dataInfo', ...(require('/data/src/models/dataInfo.js').default) });
app.model({ namespace: 'global', ...(require('/data/src/models/global.js').default) });
app.model({ namespace: 'interactive', ...(require('/data/src/models/interactive.js').default) });
app.model({ namespace: 'list', ...(require('/data/src/models/list.js').default) });
app.model({ namespace: 'login', ...(require('/data/src/models/login.js').default) });
app.model({ namespace: 'menu', ...(require('/data/src/models/menu.js').default) });
app.model({ namespace: 'newApproval', ...(require('/data/src/models/newApproval.js').default) });
app.model({ namespace: 'project', ...(require('/data/src/models/project.js').default) });
app.model({ namespace: 'setting', ...(require('/data/src/models/setting.js').default) });
app.model({ namespace: 'user', ...(require('/data/src/models/user.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
